import "leaflet/dist/leaflet.css";
import "./styles.css";
import { useState, useLayoutEffect, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import LZString from "lz-string";
import Map from "./Map";
import { getIndexData } from "../../api/FlaskAPI";
import {
  setDatePickerFrom,
  setDatePickerTo,
  setAreaStats,
  setAreaImage,
  clearAllMapState,
  clearDates,
  setDownloadLink,
  setFileContent,
  setUploaderFlag,
} from "../../reducers/MapSlice";
import { setUser } from "../../reducers/userSlice";
import SignInComponent from "../../components/Sign/SignComponent";
import CollapsibleImage from "../../components/CollapsibleComponent/CollapsibleImage";
import CollapsibleChart from "../../components/CollapsibleComponent/CollapsibleChart";
import IndexLegend from "../../components/IndexLegend";
import { useTranslation } from "react-i18next";
import { DateRangePicker } from "rsuite";
import { CustomProvider } from "rsuite";
import arEG from "rsuite/locales/ar_EG";
import useApi from "../../hooks/useApi";
import { useMap } from "react-leaflet/hooks";
import { useMemo } from "react";
import { toast } from "react-toastify";
import CoordinatesInput from "../../components/CoordinatesInput";
import NavPageSelector from "../../components/NavPageSelector";
import * as constants from "../../utils/constants";
import { getChartData, getWeatherChartdata } from "../../utils/charts_format";
import MobileIcon from "../../assets/images/onlyMobile.png";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import MonitoringDialog from "../Masking/MonitoringDialog";
import LandDegradationDialog from "../LandDegradation/LandDegradationDialog";
import IndexInfoDialog from "../../components/IndexInfoDialog";
import AddTiffDialog from "../../components/AddTiffDialog";
import { resetStore } from "../../reducers/resetStore";
import { url } from "../../api/axios_client";
import axios from "../../api/axios_client";
import { useAdmin } from "../../hooks/useAdmin";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import Stripe from "./Stripe";
import { CircularProgress } from "@mui/material";
let indexData;

const getLegendData = (dataKey) => {
  try {
    // Get and parse categories from localStorage
    const categoriesStr = localStorage.getItem("categories");
    const categories = JSON.parse(categoriesStr);

    // Find the index data that matches the dataKey
    indexData = categories.find((category) => {
      return (
        category.type.toLowerCase() === dataKey.toLowerCase() ||
        (category.category &&
          category.category.toLowerCase() === dataKey.toLowerCase()) ||
        (category.name && category.name.toLowerCase() === dataKey.toLowerCase())
      );
    });

    if (!indexData) {
      console.log("No matching index found for:", dataKey);
      return null;
    }

    if (!indexData) return null;

    // Parse the legends array
    const legends = indexData.legends.map((legendStr) => {
      // Remove single quotes and parse the string as JSON
      const cleanStr = legendStr.replace(/'/g, '"');
      const legendObj = JSON.parse(cleanStr);
      return {
        value: legendObj.label ?? legendObj.value,
        value_ar: legendObj.label_ar,
        color: legendObj.color,
      };
    });
    return {
      title: indexData.name,
      unit: indexData.unit,
      unit_ar: indexData.unit_ar,
      legends,
    };
  } catch (error) {
    console.error("Error parsing legend data:", error);
    return null;
  }
};

export default function BaseBage({
  dataKey,
  monitoringKey,
  imageEndpoint,
  statsEndpoint,
  tiffEndopoint,
  route,
  legendImg,
  land_cover_dataset,
}) {
  const isAdmin = useAdmin();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [landDegradationOpen, setLandDegradationOpen] = useState(false);
  const [indexInfoOpen, setIndexInfoOpen] = useState(false);
  const [addTiffOpen, setAddTiffOpen] = useState(false);
  const [mainIndex, setMainIndex] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [tiffLoading, setTiffLoading] = useState(false); // TIFF loading state
  
  const handleOpen = () => {
    if (!areas || !areas[0] || !areas[0].coordinates) {
      toast.error("Please select the area you want to be monitored");
    } else {
      setMainIndex(monitoringKey);
      setOpen(true);
    }
  };
  const handleLandDegradationOpen = () => {
    if (!areas || !areas[0] || !areas[0].coordinates) {
      toast.error("Please select the area first");
    } else {
      setLandDegradationOpen(true);
    }
  };
  const handleIndexInfoOpen = () => {
    setIndexInfoOpen(true);
  };
  const handleAddTiffOpen = () => {
    setAddTiffOpen(true);
  };

  const handleClose = () => {
    // dispatch(resetStore());
    setOpen(false);
  };
  const { t, i18n } = useTranslation();
  const mapData = null;
  const legendData = getLegendData(dataKey);
  console.log("LEGGGGEEEND", legendData);
  const isWeatherPage = dataKey === "WeatherMonitoring";
  const loggedInUser = localStorage.getItem(constants.USER);
  const w = window.innerWidth;
  const h = window.innerHeight;
  const [isMobile, setIsMobile] = useState(w < 700);

  const [legendHidden, setLegendHidden] = useState(false);

  //user states
  const loggedUserState = useSelector((state) => state.userState.user);
  //map states
  const areas = useSelector((state) => state.mapState.areas);
  const datePickerTimeFrom = useSelector(
    (state) => state.mapState.date.datePickerTimeFrom
  );
  const datePickerTimeTo = useSelector(
    (state) => state.mapState.date.datePickerTimeTo
  );
  const downloadLink = useSelector((state) => state.mapState.downloadLinks);

  const currentIndexId = localStorage.getItem("currentIndexId");

  const [fetchFaoImage, setFetchFaoImage] = useState(false);
  const polyStatsRequest = useApi(statsEndpoint);
  const polyImageRequest = useApi(imageEndpoint);
  const getTiffReq = useApi(tiffEndopoint);
  const indexDataRequest = useApi(getIndexData);
  const weatherStatsData = useSelector((state) => state.mapState.weatherStats);

  useEffect(() => {
    dispatch(setUser(JSON.parse(loggedInUser)));

    // Restore map file content if it exists
    const retrievedCompressed = localStorage.getItem("mapFileContent") ?? "";
    const savedMapContent = LZString.decompress(retrievedCompressed);
    if (savedMapContent) {
      dispatch(setFileContent(JSON.parse(savedMapContent)));
      dispatch(setUploaderFlag(true));
    }
  }, [loggedInUser, dispatch]);

  useLayoutEffect(() => {
    return () => {
      // Don't clear the entire map state on unmount
      // Only clear what's necessary
      toast.dismiss();
      const controller = new AbortController();
      controller.abort();
    };
  }, []);

  // Helper function to get error message based on language
  const getErrorMessage = (error, msg = "") => {
    if (error.response?.data) {
      const isArabic = i18n.language === "ar";
      return isArabic
        ? error.response.data.message_ar || error.response.data.message
        : error.response.data.message;
    }
    if (msg) return msg;
    return "An error occurred";
  };

  const updateIndex = async (index) => {
    try {
      const response = await axios.put(`${url}/indexes/${indexData.id}`, {
        index,
      });

      if (response.status === 200) {
        toast.success("Data fetched successfully");
      }
    } catch (error) {
      console.error("Error updating index:", error);
      const errorMessage = getErrorMessage(error, "Failed to update index");
      toast.error(errorMessage);
    }
  };

  /**
   * fetches the stats of area at index j
   * @param {*} j the index of area
   *
   */

  const getPolyXStats = async (j) => {
    if ("LandCover".includes(dataKey)) return;
    console.log("stats req begin");

    try {
      const res = await indexDataRequest.request(
        {
          id: currentIndexId,
          request_type: "stats",
          coordinates: Array.isArray(areas[j].coordinates)
            ? areas[j].coordinates
            : null,
          geo: Array.isArray(areas[j].coordinates)
            ? null
            : JSON.stringify(areas[j].coordinates),
          from_date: datePickerTimeFrom,
          to_date: datePickerTimeTo,
        },
        true
      );

      // Can't connect to server
      if (!res) {
        toast.error(t("request_error"));
        return;
      }

      if (res.status !== 200) {
        const errorMessage =
          res.data?.message || res.data?.errors || t("Map.stats_request_error");
        toast.error(errorMessage);
        return;
      }

      // Success
      console.log("stats res", res);
      dispatch(
        setAreaStats({
          polyId: areas[j].polyId,
          data: {
            timestamps: Object.values(res.data.data.TimeStamp),
            stats: Object.values(res.data.data.mean),
            mean: Object.values(res.data.data.mean),
            max: Object.values(res.data.data.max),
            min: Object.values(res.data.data.min),
            selected: "mean",
            unit: res.data.data.unit,
          },
        })
      );
    } catch (error) {
      console.error("Error fetching stats:", error);
      const errorMessage = getErrorMessage(error, t("Map.stats_request_error"));
      toast.error(errorMessage);
    }
  };

  /**
   * fetch image of j area from our server
   *
   * @param  {int} j the index of area
   */
  const getXImage = async (j) => {
    console.log("png req begin");

    try {
      const res = await indexDataRequest.request(
        {
          id: currentIndexId,
          request_type: "image",
          coordinates: Array.isArray(areas[j].coordinates)
            ? areas[j].coordinates
            : null,
          geo: Array.isArray(areas[j].coordinates)
            ? null
            : JSON.stringify(areas[j].coordinates),
          from_date: datePickerTimeFrom,
          to_date: datePickerTimeTo,
          land_cover_dataset: JSON.stringify(land_cover_dataset),
        },
        false
      );

      console.log("png res", res);

      // Can't connect to server
      if (!res) {
        toast.error(t("request_error"));
        return;
      }

      if (res.status !== 200) {
        const errorMessage = getErrorMessage(
          { response: res },
          t("Map.image_request_error")
        );
        toast.error(errorMessage);
        return;
      }

      // Success
      dispatch(
        setAreaImage({
          polyId: areas[j].polyId,
          img64: res.data.imgdata,
          bbox: res.data.bounds,
          imagename: res.data.imagename,
        })
      );
    } catch (error) {
      console.error("Error fetching image:", error);
      const errorMessage = getErrorMessage(error, t("Map.image_request_error"));
      toast.error(errorMessage);
    }
  };

  const getTiffImage = async (j) => {
    console.log("tiff req begin");

    try {
      const response = await indexDataRequest.request(
        {
          id: currentIndexId,
          request_type: "tiff",
          coordinates: Array.isArray(areas[j].coordinates)
            ? areas[j].coordinates
            : null,
          geo: Array.isArray(areas[j].coordinates)
            ? null
            : JSON.stringify(areas[j].coordinates),
          from_date: datePickerTimeFrom,
          to_date: datePickerTimeTo,
          land_cover_dataset: JSON.stringify(land_cover_dataset),
        },
        false
      );

      console.log("tiff res", response);

      // Can't connect to server
      if (!response) {
        toast.error(t("request_error"));
        return;
      }

      if (response.status !== 200) {
        const errorMessage = getErrorMessage(
          { response: response },
          "Failed to download TIFF file"
        );
        toast.error(errorMessage);
        return;
      }

      // Success
      dispatch(setDownloadLink(response.data));
      const link = document.createElement("a");
      link.href = response.data;
      link.download = "";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("TIFF file downloaded successfully");
    } catch (error) {
      console.error("Error fetching TIFF:", error);
      const errorMessage = getErrorMessage(
        error,
        "Failed to download TIFF file"
      );
      toast.error(errorMessage);
    }
  };
  /**
   * checks whether to fetch image from fao or our api
   * then fetch images of given indexes
   * @param  {int} polyIndexes int indexes of images to fetch
   */

  const fetchImagesAtIdx = async (...polyIndexes) => {
    try {
      // Request images from our server
      const promises = polyIndexes.map((j) => getXImage(j));
      await Promise.allSettled(promises); // Use allSettled to handle individual errors
    } catch (error) {
      console.error("Error fetching images:", error);
      toast.error("Failed to fetch some images");
    }
  };

  const fetchTiffImage = async (index) => {
    if (areas.length === 0) {
      toast.warn("No areas selected");
      return;
    }

    setTiffLoading(true); // Start loading
    try {
      await getTiffImage(index);
    } catch (error) {
      console.error("Error in fetchTiffImage:", error);
      const errorMessage = getErrorMessage(error, "Failed to fetch TIFF image");
      toast.error(errorMessage);
    } finally {
      setTiffLoading(false); // End loading
    }
  };
  /**
   *
   * handles the user submit action, fetches the images and stats
   */
  const handleClickSubmit = async () => {
    // TODO: check if polygon is inside arab land
    if (areas.length === 0) return;

    if (areas.length > 2) {
      toast.warn("Please select only 2 areas");
      return;
    }

    setSubmitLoading(true);
    try {
      if (areas.length === 1) {
        // Fetch data for polygon 0
        await fetchImagesAtIdx(0);
        // await getPolyXStats(0); // Uncomment if needed
      }

      if (areas.length === 2) {
        if (JSON.stringify(chartData) === "{}") {
          // If no data exists call fetch for polygon 0 & 1
          await fetchImagesAtIdx(0, 1);
          // await getPolyXStats(0); // Uncomment if needed
          // await getPolyXStats(1); // Uncomment if needed
        } else {
          // Some data exists, means we need polygon 1 data
          await fetchImagesAtIdx(1);
          // await getPolyXStats(1); // Uncomment if needed
        }
      }
    } catch (error) {
      console.error("Error in handleClickSubmit:", error);
      const errorMessage = getErrorMessage(error, "Failed to process request");
      toast.error(errorMessage);
    } finally {
      setSubmitLoading(false);
    }
  };

  /**
   * controls submit button enable state,
   * @returns boolean value to disable or enable button
   */
  const disableBtn = () => {
    if (submitLoading) return true;
    if (datePickerTimeFrom === "" || datePickerTimeTo === "") return true;
    if (areas.length === 0) return true;
    if (areas.length > 2) return true;
    if (chartData?.series?.length >= 2) return true;
    return false;
  };

  const getChartDataMemoized = useMemo(
    () => () => getChartData(dataKey, loggedUserState, areas),
    [areas, dataKey, loggedUserState]
  );
  const getWeatherDataMemoized = useMemo(
    () => () => getWeatherChartdata(weatherStatsData, loggedUserState, t),
    [loggedUserState, t, weatherStatsData]
  );
  const chartData = isWeatherPage
    ? getWeatherDataMemoized()
    : getChartDataMemoized();

  return (
    <>
      <div className="monitoring-container">
        <div className="map-wrapper">
          {!isMobile && (
            <Stripe>
              <NavPageSelector route={route} />
              <div className="stripe-content">
                <LanguageSwitcher stripe={true} />
                <SignInComponent
                  menuIconColor="black"
                  backgroundColor="white"
                  classN="modalcontainer-base"
                  stripe={true}
                />
              </div>
            </Stripe>
          )}
          {
            <Stripe second={true}>
              <CoordinatesInput disableFileUpload={isWeatherPage} />
              {!isWeatherPage && dataKey && (
                <>
                  <div className="second-stripe-btns">
                    {isAdmin && (
                      <button
                        className="submit-compare-buttons"
                        onClick={handleOpen}
                      >
                        {t("Map.monitoring")}
                      </button>
                    )}

                    <button
                      className="submit-compare-buttons"
                      onClick={handleIndexInfoOpen}
                    >
                      {t("Map.index_info")}
                    </button>
                    {isAdmin && (
                      <button
                        className="submit-compare-buttons"
                        onClick={handleAddTiffOpen}
                      >
                        {t("Map.add_tiff")}
                      </button>
                    )}
                  </div>
                </>
              )}
              {dataKey && (
                <div className="stripe-select-date">
                  <p className="dateParagraph">{t("Map.select_date")}</p>
                  <CustomProvider
                    locale={i18n.language === "ar" ? arEG : undefined}
                    rtl
                  >
                    <DateRangePicker
                      size={isMobile ? "sm" : "default"}
                      placement="autoVerticalStart"
                      showOneCalendar={isMobile}
                      cleanable
                      appearance={isMobile ? "subtle" : "default"}
                      value={
                        datePickerTimeFrom && datePickerTimeTo
                          ? [new Date(datePickerTimeFrom), new Date(datePickerTimeTo)]
                          : null
                      }
                      onOk={(date) => {
                        const fromDate = new Date(date[0]);
                        const toDate = new Date(date[1]);
                        fromDate.setHours(12, 0, 0, 0);
                        toDate.setHours(12, 0, 0, 0);
                        dispatch(
                          setDatePickerFrom(
                            fromDate.toISOString().split("T")[0]
                          )
                        );
                        dispatch(
                          setDatePickerTo(toDate.toISOString().split("T")[0])
                        );
                      }}
                      onClean={() => dispatch(clearDates())}
                    />
                  </CustomProvider>
                  <button
                    onClick={handleClickSubmit}
                    className="submit-compare-buttons"
                    disabled={disableBtn()}
                    style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      gap: '8px',
                      minWidth: '100px'
                    }}
                  >
                    {submitLoading ? (
                      <>
                        <CircularProgress size={16} color="inherit" />
                        <span>{t("loading")}</span>
                      </>
                    ) : (
                      t("submit")
                    )}
                  </button>
                </div>
              )}
            </Stripe>
          }

          {isMobile && <NavPageSelector route={route} />}
          {/* 
          {dataKey && isMobile && (
          <div className="dates">
            <p className="dateParagraph">{t("Map.select_date")}</p>
            <DateRangePicker
            size={isMobile ? "sm" : "default"} 
            placement="autoVerticalStart" 
            showOneCalendar={isMobile}
            cleanable
            appearance={isMobile ? "subtle" : "default"} 
            onOk={(date) => {
              if (date && date.length === 2) {
                const fromDate = new Date(date[0]);
                const toDate = new Date(date[1]);
                fromDate.setHours(12, 0, 0, 0);
                toDate.setHours(12, 0, 0, 0);

                dispatch(
                  setDatePickerFrom(fromDate.toISOString().split("T")[0])
                );
                dispatch(
                  setDatePickerTo(toDate.toISOString().split("T")[0])
                );
              }
            }}
              onClean={() => dispatch(clearDates())}
            />
            {!isMobile && 
          <button
            onClick={handleClickSubmit}
            className="submit-compare-buttons"
            disabled={disableBtn()}
          >
            {t("submit")}
          </button>
          }
          </div>)} */}

          {/* {isMobile && <CoordinatesInput disableFileUpload={isWeatherPage} />} */}
          {/* <CoordinatesInput disableFileUpload={isWeatherPage} /> */}
          <Map
            legendData={legendData}
            index={dataKey}
            // tileFunction={() =>
            //   GetTiles(dataKey, areas, datePickerTimeFrom, setFetchFaoImage)
            // }
            // fetchFaoImage={fetchFaoImage}

            showEditControl={!isWeatherPage}
          />
        </div>
      </div>

      {!isWeatherPage && dataKey && (
        <div className="submit-compare-buttons-container button-container">
          {/*{isMobile && 
          <>
          <button
            onClick={handleClickSubmit}
            className="submit-compare-buttons"
            disabled={disableBtn()}
          >
            {t("submit")}
          </button>
          
          {isAdmin && <button
            className="submit-compare-buttons"
            onClick={handleOpen}
          >
            Monitoring
          </button>}
          <button
            className="submit-compare-buttons"
            onClick={handleIndexInfoOpen}
          >
            Index Info
          </button>
          {isAdmin && <button
            className="submit-compare-buttons"
            onClick={handleAddTiffOpen}
          >
            Add Tiff
          </button>}
          </>}*/}
          <IndexInfoDialog
            open={indexInfoOpen}
            index={indexData}
            onSave={updateIndex}
            onClose={() => setIndexInfoOpen(false)}
          />
          <AddTiffDialog
            open={addTiffOpen}
            index={indexData}
            onClose={() => setAddTiffOpen(false)}
          />
          <LandDegradationDialog
            mainIndex={mainIndex}
            open={landDegradationOpen}
            onClose={() => setLandDegradationOpen(false)}
          />
          <MonitoringDialog
            mainIndex={mainIndex}
            open={open}
            handleClose={handleClose}
          />
        </div>
      )}

      {/* {isMobile && (
        <div className="mobile-popup-container">
          <div className="mobile-popup-icon-container">
            <img src={MobileIcon} className="mobile-popup-icon" />
            <span className="mobile-popup-text">
              This site is not suited for mobile use , to enjoy it more , use a
              desktop device{" "}
            </span>
          </div>
          <button
            className="mobile-popup-button"
            onClick={() => setIsMobile(false)}
          >
            OK
          </button>
        </div>
      )} */}

      {[...areas].splice(0, 2).map((area, idx) => {
        return (
          <CollapsibleImage
            handleDownloadTiff={fetchTiffImage}
            tiffLoading={tiffLoading} // Pass loading state
            key={`${idx}-${Math.random() * 1000}`}
            index={idx}
            imgsrc={
              area.imgurl ||
              (area.img64 && `data:image/png;base64,${area.img64}`)
            }
            name={`${area.imagename} Image`}
            compstyle={idx === 1 ? "-comp" : ""}
          />
        );
      })}

      {/* <CollapsibleChart chartData={chartData} datakey={dataKey} /> */}

      {/* {!isWeatherPage && (

      )} */}
    </>
  );
}